(function () {
  document.addEventListener("shopify:section:load", function (e) {
    $(".product-section .product__media-list-wrapper").each(function () {
      const $wrap = $(this);
      const $main = $wrap.find(".product__media-list").first();
      const $sub = $wrap.find(".product__media-sublist").first();
      const mediaWrapper = $wrap.closest(".product__media-wrapper")[0];
      $main.slick(getSliderSettings($sub, mediaWrapper));
      $sub.slick(getSubSliderProductSettings($main));
    });

    $(".product-section .product__media-list").on(
      "afterChange",
      function (event, slick, currentSlide, nextSlide) {
        window.pauseAllMedia();
      }
    );
  });
})();
